import { MessageCircle, Heart, Users, Sparkles } from "lucide-react";

const benefits = [
  {
    icon: MessageCircle,
    title: "Communicate Clearly",
    description: "Express ideas with confidence and precision",
  },
  {
    icon: Heart,
    title: "Feel Present & Calm",
    description: "Ground yourself in high-pressure moments",
  },
  {
    icon: Sparkles,
    title: "Build Self-Trust",
    description: "Develop authentic confidence from within",
  },
  {
    icon: Users,
    title: "Collaborate Better",
    description: "Connect meaningfully with teams and clients",
  },
];

const struggles = [
  "They shrink",
  "They second-guess themselves",
  "They disconnect or burn out",
];

const outcomes = [
  "Find their voice",
  "Take up space",
  "Feel at home in themselves at work",
];

export default function WhyMattersSection({ isVisible }) {
  return (
    <section
      id="why-matters"
      className={`py-24 lg:py-32 bg-[#EAE3D9] transition-all duration-700 ${
        isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"
      }`}
      data-testid="why-matters-section"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="font-['Cormorant_Garamond'] text-3xl sm:text-4xl lg:text-5xl font-medium text-[#1A1A1A] mb-6 heading-decorated-center">
            Why This Work Matters
          </h2>
        </div>

        {/* Benefits Grid */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6 mb-20">
          {benefits.map((benefit, index) => (
            <div
              key={benefit.title}
              className="bg-[#F9F6F0] p-6 border border-[#C5A059]/30 card-hover"
              style={{ animationDelay: `${index * 100}ms` }}
              data-testid={`benefit-card-${index}`}
            >
              <benefit.icon
                size={32}
                strokeWidth={1.5}
                className="text-[#8B5A2B] mb-4"
              />
              <h3 className="font-['Cormorant_Garamond'] text-xl font-medium text-[#1A1A1A] mb-2">
                {benefit.title}
              </h3>
              <p className="font-['Manrope'] text-sm text-[#4A4542]">
                {benefit.description}
              </p>
            </div>
          ))}
        </div>

        {/* Contrast Section */}
        <div className="grid lg:grid-cols-2 gap-8 lg:gap-12">
          {/* When they don't */}
          <div className="bg-[#1A1A1A] p-8 lg:p-10">
            <h3 className="font-['Cormorant_Garamond'] text-2xl font-medium text-[#F9F6F0] mb-6">
              When people don't feel safe, seen and heard...
            </h3>
            <ul className="space-y-4">
              {struggles.map((item, index) => (
                <li
                  key={index}
                  className="font-['Manrope'] text-[#EAE3D9] flex items-start"
                >
                  <span className="w-2 h-2 bg-[#C5A059] rounded-full mt-2 mr-3 flex-shrink-0"></span>
                  {item}
                </li>
              ))}
            </ul>
          </div>

          {/* When they do */}
          <div className="bg-[#F9F6F0] p-8 lg:p-10 border border-[#C5A059]/30">
            <h3 className="font-['Cormorant_Garamond'] text-2xl font-medium text-[#1A1A1A] mb-6">
              This work creates spaces where people can...
            </h3>
            <ul className="space-y-4">
              {outcomes.map((item, index) => (
                <li
                  key={index}
                  className="font-['Manrope'] text-[#4A4542] flex items-start"
                >
                  <span className="w-2 h-2 bg-[#8B5A2B] rounded-full mt-2 mr-3 flex-shrink-0"></span>
                  {item}
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}
